export default __webpack_public_path__ + "static/media/keyvis_text_dt.5c2628cb.png";